const LeaveRow = function($containerEl, dayModel, last)
{
    TemplateView.call(this, $containerEl);
    this.dayModel = dayModel;
    this.last = last;
};

LeaveRow.prototype = _.create(TemplateView.prototype, {
    html: "<tr class='leaveRow'>" +
          "  <td class='nameColumn'>" +
          "    <div class='subContainer'>" +
          "      <img class='noprint' src='<%=imageUrl%>'/>" +
          "      <img class='printImgType for-print-only' src='<%=printImageUrl%>'/>" +
          "      <span class='name'><%-name%></span>" +
          "    </div>" +
          "  </td>" +
          "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
          "  <td class='detailsColumn'></td>" +
          "</tr>",

    afterRender: function()
    {
        this.$el.toggleClass("locked", this.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.dayModel.workdayDuration == 0);
        this.$el.toggleClass("nonLast", !this.last);
    },

    templateModel: function()
    {
        var leaveType = LeaveTypeStore.getLeaveType(this.dayModel.leave.leaveTypeId);
        return {
            imageUrl: getLeaveTypeIconPath(leaveType.iconId),
            printImageUrl: getLeaveTypePrintIconPath(leaveType.iconId),
            name: leaveType.name,
            total: UserTime.formatTimeWithDigitSeparator(this.dayModel.leave.leaveTime)
        }
    }
});

export default LeaveRow


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/LeaveRow.js